var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPattern1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 56,
    viewBox: "0 0 55 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5691 47.1555V41.9095L23.5625 41.9157H26.1704V39.2891H23.5625L23.5691 39.2948C23.5665 38.4199 23.5641 37.5447 23.562 36.6691H28.8162V34.063H31.4303V36.6576H34.0507V31.4284L34.0441 31.4346C34.1551 31.4346 34.2662 31.431 34.3767 31.431L41.9102 31.427V34.0363H44.5119V31.4337H41.9044V28.7996H36.6592V23.5846H28.798V26.1978H23.5802V31.4426H26.174V34.0581H23.5683V36.6785H20.9505V34.0523H13.0938V31.4395H20.9376V10.4716H23.5683L23.562 10.4653C23.562 12.988 23.5632 15.5108 23.5656 18.0338V18.3131H26.1833V13.0999H28.7966V18.3327H31.4295L31.4232 18.3265V20.9442H44.5204V23.5588H47.1456V26.1929L47.1523 26.1872H44.5443V28.8138H47.1523L47.1456 28.8075V34.055H49.7723L49.766 34.0488V39.2824H47.1639V44.5365H49.7723L49.766 44.5303V47.1507H54.9984V49.7657H47.1545V55.0065H44.5386V52.3945H39.2853L39.2915 52.4007V49.7804H36.6774V47.1649H41.8937V44.5445H28.8162V47.1493H23.5629L23.5691 47.1555ZM39.2853 39.2944V36.6865H36.684V39.2895H39.292V41.8975H44.5124V39.2957L39.2853 39.2944ZM34.0374 39.3068H31.4446V41.8988H34.0374V39.3068ZM39.2978 26.1743H41.8906V23.5814H39.2978V26.1743Z",
    fill: "#2965FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5701 10.4682V5.22744H20.959V0H34.0348V5.21678H31.4455V7.84071H34.0379V13.0686H31.4308V10.4691H28.8149V7.85581H26.1976V10.4611H23.5638L23.5701 10.4682ZM26.1976 5.20789H28.79V2.61505H26.1976V5.20789Z",
    fill: "#2965FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0811 23.5649V26.1853H18.3139V28.8008H10.4692V34.0416H0V28.823H2.59509V31.411H7.84788V23.5649L7.84122 23.5712H13.0874L13.0811 23.5649Z",
    fill: "#2965FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5637 47.146V49.7664H26.1793V52.3819H28.793V55.0023H20.9629V47.1522H23.57L23.5637 47.146Z",
    fill: "#2965FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.84894 23.5646H2.61081V26.1748H0.00195312V20.9629H7.84228V23.5708L7.84894 23.5646Z",
    fill: "#2965FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9976 28.7984H52.3985V23.5763H49.7861V20.9595H54.9976V28.7984Z",
    fill: "#2965FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0853 23.5713V20.9629H18.3088V23.5651H13.0791L13.0853 23.5713Z",
    fill: "#2965FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7738 34.0508V31.4429H52.3769V34.0446H49.7676L49.7738 34.0508Z",
    fill: "#2965FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4023 36.6807H54.9948V39.2775H52.4023V36.6807Z",
    fill: "#2965FF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M31.433 18.3311V15.7231H34.0361V18.3249H31.4268L31.433 18.3311Z",
    fill: "#2965FF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5713 41.9046H20.9629V39.29H23.5713L23.5646 39.2842V41.9108L23.5713 41.9046Z",
    fill: "#2965FF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7738 44.5323V41.9243H52.3769V44.526H49.7676L49.7738 44.5323Z",
    fill: "#2965FF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1455 26.1903H49.7539V28.805H47.1455L47.1522 28.8112V26.1846L47.1455 26.1903Z",
    fill: "#2965FF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0345 52.3824H31.4395V49.7896H34.0328L34.0345 52.3824Z",
    fill: "#2965FF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2896 52.3892V54.9971H36.6865V52.3954H39.2958L39.2896 52.3892Z",
    fill: "#2965FF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9948 54.9986H52.4023V52.4058H54.9948V54.9986Z",
    fill: "#2965FF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0527 31.4239H31.4443V28.8208H34.0461V31.4301L34.0527 31.4239Z",
    fill: "#2965FF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPattern1);
export default __webpack_public_path__ + "static/media/pattern1.c15839cd205b841066ffd0050cc091e6.svg";
export { ForwardRef as ReactComponent };